<template>
  <div class="flex flex-col overflow-x-auto">
    <div class="">
      <div class="py-2 align-middle inline-block min-w-full">
        <div
          class="shadow border-b border-gray-200 sm:rounded-lg"
        >
          <table class="min-w-full divide-y divide-gray-200">
            <thead>
              <tr>
                <th
                  scope="col"
                  class="px-6 py-3 bg-gray-50 text-left text-gray-dark text-sm font-medium uppercase tracking-wider"
                >
                  Date
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 bg-gray-50 text-left text-sm text-gray-dark font-medium uppercase tracking-wider"
                >
                  Time
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 bg-gray-50 text-left text-sm text-gray-dark font-medium uppercase tracking-wider"
                >
                  Users
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 bg-gray-50 text-left text-sm text-gray-dark font-medium uppercase tracking-wider"
                >
                  Cost
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 bg-gray-50 text-left text-sm text-gray-dark font-medium uppercase tracking-wider"
                >
                  Earnings
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 bg-gray-50 text-left text-sm text-gray-dark font-medium uppercase tracking-wider"
                >
                  Avg Rating
                </th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200" v-if="data.length">
              <tr v-for="d in data" :key="d.id">
                <td class="px-6 py-4 whitespace-nowrap text-xs text-gray-350">
                  {{ handleMonthDateTime(d.start_date) }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-xs text-gray-350">
                  {{ handleHour12(d.start_date) }} -
                  {{ handleHour12(d.end_date) }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-xs text-gray-350">
                  {{ d.total_joined_users }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-xs text-gray-350">
                  {{ d.cost ? `$${d.cost}` : "-" }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-xs text-gray-350">
                  {{ d.total_earnings ? `$${d.total_earnings}` : "-" }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-xs text-gray-350">
                  <Rating :data="d.average_rating" />
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-xs text-gray-350">
                  <span v-if="d.is_private"><EyeOff /></span>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-if="!data.length">
            <EmptyTable
              :description="'Schedule and complete classes to see your class history.'"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EyeOff } from "@/components/icons";
import { Rating, EmptyTable } from "@/components/t-components";

export default {
  name: "SessionHistory",
  components: {
    Rating,
    EyeOff,
    EmptyTable,
  },
  props: ["data"],
};
</script>